import { render, staticRenderFns } from "./addCommercialGrade.vue?vue&type=template&id=cc6d2864&scoped=true"
import script from "./addCommercialGrade.vue?vue&type=script&lang=js"
export * from "./addCommercialGrade.vue?vue&type=script&lang=js"
import style0 from "./addCommercialGrade.vue?vue&type=style&index=0&id=cc6d2864&prod&lang=scss&scoped=true"
import style1 from "./addCommercialGrade.vue?vue&type=style&index=1&id=cc6d2864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6d2864",
  null
  
)

export default component.exports